<gtd-ui-field-default-string-or-empty [data]="tokenTypesLabels[data.toLowerCase()]"></gtd-ui-field-default-string-or-empty>
